const data = {
  id: 1,
  title: 'Read and complete the paragraph with the given words',
  subTitle: 'Đọc và điền từ để hoàn thành đoạn văn',
  words: ['address', 'street', 'live'],
  questions: ['What is your #?', "It's 45 Quang Trung #. Where do you live?", 'I # in Trang An apartment.'],
  answers: ['address', 'street', 'live'],
  settings: {
    showNumber: false,
  },
};

export default data;
